module.exports = __webpack_public_path__ + "media/images/rank/diamond-sm-bfa209994d429f025db5d98430d239f5.svg";